import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { mobileDrawerDriverFactory } from './MobileDrawer.driver';
import { MobileDrawer, MobileDrawerProps } from '.';

describe('MobileDrawer', () => {
  const createDriver = createRendererWithUniDriver(mobileDrawerDriverFactory);

  const bootstrap = (props: Partial<MobileDrawerProps> = {}) => {
    return createDriver(<MobileDrawer {...props} />);
  };

  it('should render', async () => {
    const { driver } = bootstrap();
    expect(await driver.exists()).toBe(true);
  });

  it('should render children', async () => {
    const { driver } = createDriver(
      <MobileDrawer isOpen>
        <div data-hook="drawer-children">Drawer children</div>
      </MobileDrawer>,
    );
    expect(await driver.childExists('[data-hook="drawer-children"]')).toBe(
      true,
    );
  });

  it('should NOT render children if MobileDrawer not open', async () => {
    const { driver } = createDriver(
      <MobileDrawer>
        <div data-hook="drawer-children">Drawer children</div>
      </MobileDrawer>,
    );
    expect(await driver.childExists('[data-hook="drawer-children"]')).toBe(
      false,
    );
  });

  it('expect mobileDrawer to be isOpen false as default', async () => {
    const { driver } = createDriver(<MobileDrawer>Children</MobileDrawer>);

    expect(await driver.isOpen()).toBe(false);
  });

  it('expect mobileDrawer to be isOpen if open', async () => {
    const { driver } = createDriver(
      <MobileDrawer isOpen>Cildren</MobileDrawer>,
    );

    expect(await driver.isOpen()).toBe(true);
  });

  it('should open and render children when appendToBody prop is set to true', async () => {
    const { driver } = createDriver(
      <MobileDrawer isOpen appendToBody>
        <div data-hook="drawer-children">Drawer children</div>
      </MobileDrawer>,
    );
    expect(await driver.isOpen()).toBe(true);
    expect(await driver.childExists('[data-hook="drawer-children"]')).toBe(
      true,
    );
  });
});
